import React, { useCallback } from 'react';
import { Label, Pane, Selector } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import { useValueChange } from '@leverege/ui-hooks';
import Model from "./CSVExportFormatterModel.js";
import S from './ExportFormatterEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.export.CSVExportFormatterEditor');
const separatorOptions = [{
  value: ',',
  get name() {
    return t('comma');
  }
}, {
  value: ';',
  get name() {
    return t('semiColon');
  }
}, {
  value: '\t',
  get name() {
    return t('tab');
  }
}];
const extensionOptions = [{
  value: 'csv',
  get name() {
    return t('csv');
  }
}, {
  value: 'tsv',
  get name() {
    return t('tsv');
  }
}];
export default function CSVExportFormatterEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  const onSeparatorChange = useCallback(evt => {
    let extension;
    if (evt.value === '\t') {
      extension = 'tsv';
    } else {
      extension = 'csv';
    }
    onModelChange({
      value: extension,
      data: 'setExtension'
    });
    setTimeout(() => {
      onModelChange(evt);
    }, 1);
  }, [onModelChange]);
  return /*#__PURE__*/_jsxs(Pane, {
    className: S.grid,
    children: [/*#__PURE__*/_jsx(Label, {
      children: t('separator')
    }), /*#__PURE__*/_jsx(Selector, {
      eventData: "setSeparator",
      value: Model.getSeparator(value),
      values: separatorOptions,
      onChange: onSeparatorChange
    }), /*#__PURE__*/_jsx(Label, {
      children: t('extension')
    }), /*#__PURE__*/_jsx(Selector, {
      eventData: "setExtension",
      value: Model.getExtension(value),
      values: extensionOptions,
      onChange: onModelChange
    })]
  });
}